import { ThemeUICSSObject } from 'theme-ui';
import { mainThemeEmitter } from './useMainTheme';

/**
 * Esta función permite agregar estilos al tema principal de la aplicación, de
 * modo que estén disponibles para cualquier componente que lo requirea.
 *
 * @example
 *
 * injectStyles('buttons.myRedButton', {
 *   variant: 'buttons.primary',
 *   backgroundColor: 'red',
 * })
 */
export function injectStyles(path: string, styles: ThemeUICSSObject): void;

/**
 * Esta función permite agregar estilos al tema principal de la aplicación, de
 * modo que estén disponibles para cualquier componente que lo requirea.
 *
 * @example
 *
 * injectStyles({
 *  layout: {
 *    panels: {
 *      myPanel: {
 *        ...
 *      }
 *    }
 *  }
 * })
 */
export function injectStyles(styles: ThemeUICSSObject): void;

export function injectStyles(
  par1: string | ThemeUICSSObject,
  par2?: ThemeUICSSObject,
) {
  const path = typeof par1 === 'string' ? par1 : '';
  const styles = typeof par1 === 'string' ? (par2 as ThemeUICSSObject) : par1;

  mainThemeEmitter.emit('newStyles', { path, styles });
}
